'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiChartAreaOutline = function TiChartAreaOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm33.3 28.3h-26.6c-1 0-1.7-0.7-1.7-1.6v-5c0-1.2 0.4-2.3 1.1-3.2l6.7-8.3c1.6-2 4.8-2.4 6.9-0.9l2.8 2.1 3.6-4.5c1-1.2 2.4-1.9 3.9-1.9 1.1 0 2.2 0.4 3.1 1.1 1.2 0.9 1.9 2.4 1.9 3.9v16.7c0 0.9-0.7 1.6-1.7 1.6z m-25-3.3h23.4v-15c0-0.5-0.3-1-0.7-1.3-0.3-0.3-0.7-0.4-1-0.4-0.5 0-1 0.3-1.3 0.7l-4.6 5.8c-0.6 0.7-1.6 0.8-2.4 0.3l-4-3.1c-0.7-0.5-1.8-0.4-2.3 0.3l-6.7 8.3c-0.3 0.4-0.4 0.8-0.4 1.1v3.3z m25 10h-26.6c-1 0-1.7-0.7-1.7-1.7s0.7-1.6 1.7-1.6h26.6c1 0 1.7 0.7 1.7 1.6s-0.7 1.7-1.7 1.7z' })
        )
    );
};

exports.default = TiChartAreaOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/chart-area-outline.js
// module id = 2003
// module chunks = 0